(() => {
	angular.module('main').controller('ProfileController', ProfileController);

	ProfileController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'accountService',
		'messageService',
		'subscriptionService',
		'stringModifierService',
		'userService',
		'utilsService',
		'profileUpdateService',
		'validationService',
		'promoCodeService'
	];

	function ProfileController(
		$scope,
		$rootScope,
		$http,
		accountService,
		messageService,
		subscriptionService,
		stringModifierService,
		userService,
		utilsService,
		profileUpdateService,
		validationService,
		promoCodeService
	) {
		$scope.change_password_message = 'Change password';
		const request = {
			changeUserPassword(
				password,
				password_confirm,
				changeUserPasswordSuccessCallback,
				changeUserPasswordErrorCallback
			) {
				$scope.isSavePassSpinnningWheelActive = true;
				$http({
					method: 'POST',
					url: '/protected/rest/user/edit/password',
					data: {
						password,
						password_confirm
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
					.then(
						result => changeUserPasswordSuccessCallback(result.data),
						() => changeUserPasswordErrorCallback()
					)
					.finally(() => {
						$scope.isSavePassSpinnningWheelActive = false;
					});
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveNameSpinnningWheelActive = false;
			$scope.isASaveEmailSpinnningWheelActive = false;
			$scope.isSavePassSpinnningWheelActive = false;
			$scope.show = false;
			getUser();
			checkSubscriptionInfoUpdates();
		});

		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		$scope.$watch(
			'user',
			newVal => {
				if (newVal && newVal.subscriptionPrice) {
					setFullPrise();
				}
			},
			true
		);

		$scope.showNextModal = function(selectModal, nextModal, e) {
			utilsService.showNextModal(selectModal, nextModal, e);
		};

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
						$rootScope.hasSubscriptionBefore =
							$scope.user.hasSubscriptionBefore;
						$scope.editedUser = JSON.parse(JSON.stringify(user));
						const {
							annualDiscount,
							monthlyDiscount,
							subscribedAnnual,
							subscribedMonthly
						} = userService.subscriptionData;
						$scope.isSubscribedAnnual = subscribedAnnual;
						$scope.isSubscribedMonthly = subscribedMonthly;
						$scope.isAnnualDiscount = annualDiscount;
						$scope.isMonthlyDiscount = monthlyDiscount;

						setFullPrise();
					}
				}
			);
		}

		function setFullPrise() {
			const userData = $scope.user;

			const annualPriceType = userData.championForever
				? 'annualDiscountPrice'
				: 'annualPrice';
			const monthlyPriceType = userData.championForever
				? 'monthlyDiscountPrice'
				: 'monthlyPrice';

			const annulPrice = userData.subscriptionPrice[annualPriceType];
			const monthlyPrice = userData.subscriptionPrice[monthlyPriceType];

			$scope.fullAnnulPrice = annulPrice;
			$scope.fullMonthlyPrice = monthlyPrice;
		}

		$scope.clearPass = function() {
			$scope.show = !$scope.show;
			$scope.password = '';
			$scope.password_confirm = '';
		};

		$scope.changeName = () => {
			if (validateName()) {
				$scope.button_disable = true;
				$scope.isSaveNameSpinnningWheelActive = true;
				profileUpdateService
					.changeUserName($scope.editedUser)
					.switchMap(() => accountService.getUserWeb())
					.finally(() => {
						$scope.button_disable = false;
						$scope.isSaveNameSpinnningWheelActive = false;
					})
					.subscribe(
						data => successChangeUserName(data),
						() => messageService.showToaster('e_0', 'general')
					);
			}
		};

		function validateName() {
			let isValidName = true;

			$scope.editedUser.firstName = $scope.editedUser.firstName.trim();
			$scope.editedUser.lastName = $scope.editedUser.lastName.trim();

			if (!$scope.editedUser.firstName || $scope.editedUser.firstName === '') {
				isValidName = false;
				messageService.showToaster('e_0', 'companyUsers');
			}

			return isValidName;
		}

		function successChangeUserName(data) {
			if (data.enabled) {
				$rootScope.removeBg = 'blah';
			}
			$scope.changeUserName.firstName.$setPristine();
			$scope.changeUserName.lastName.$setPristine();

			$scope.editedUser.firstName = data.firstName;
			$scope.editedUser.LastName = data.LastName;

			messageService.showToaster('s_1', 'profile');
		}

		function isValidEmail() {
			let isValidEmail = true;

			$scope.editedUser.email = $scope.editedUser.email.trim().toLowerCase();

			if (!$scope.editedUser.email || $scope.editedUser.email === '') {
				isValidEmail = false;
				messageService.showToaster('e_0', 'general');
			} else if ($scope.editedUser.email === $scope.user.email) {
				isValidEmail = false;
				messageService.showToaster('i_2', 'profile');
			} else if (!validationService.isEmailValid($scope.editedUser.email)) {
				isValidEmail = false;
				messageService.showToaster('e_3', 'profile');
			}

			return isValidEmail;
		}

		$scope.changeEmail = () => {
			if (isValidEmail()) {
				$scope.button_disable = true;
				$scope.isASaveEmailSpinnningWheelActive = true;

				profileUpdateService
					.changeUserEmail($scope.editedUser.email)
					.switchMap(() => accountService.getUserWeb())
					.finally(() => {
						$scope.button_disable = false;
						$scope.isASaveEmailSpinnningWheelActive = false;
					})
					.subscribe(
						data => successChangeUserEmail(data),
						error =>
							messageService.showErrorFromBackend(
								'Sorry!',
								error.data.errorMessage
							)
					);
			}
		};

		function successChangeUserEmail(data) {
			$scope.editedUser.email = data.email;
			if (data.enabled) {
				$rootScope.removeBg = 'blah';
			}
			messageService.showToaster('s_2', 'profile');
		}

		$scope.changePassword = function(password, password_confirm) {
			delete $scope.userActionResult;
			if (password_confirm != password) {
				messageService.showToaster('e_0', 'profile');
			} else if (password.length < 6) {
				messageService.showToaster('e_1', 'profile');
			} else if (password.trim().length === 0) {
				messageService.showToaster('e_3', 'general', 'password');
			} else {
				delete $rootScope.error;
				delete $scope.userActionResult;
				$scope.button_disable = true;
				request.changeUserPassword(
					password,
					password_confirm,
					changeUserPasswordSuccessCallback,
					changeUserPasswordErrorCallback
				);
			}
		};

		$scope.subscribeStripeModal = function(plan, e) {
			subscriptionService.subscribeStripeModalWeb(plan, e);
		};

		function checkSubscriptionInfoUpdates() {
			promoCodeService.updateSubscriptionPriceObservable.subscribe(() => {
				accountService.getUserWeb().subscribe(() => {});
			});
		}

		function changeUserPasswordSuccessCallback(data) {
			$scope.button_disable = false;
			if (data) {
				$scope.userActionResult = data;
				messageService.showToaster('s_0', 'profile');
				$scope.company = data;
				$scope.companyName = data.name;
			}
		}

		function changeUserPasswordErrorCallback() {
			$scope.button_disable = false;
			messageService.showToaster('e_0', 'general');
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/profileController.js